const React = require('react');
const ThemeProvider = require('./theme');

exports.wrapRootElement = ({ element }) => (
    <ThemeProvider>{element}</ThemeProvider>
);
